import React from 'react';
import { Skeleton } from '@material-ui/lab';
import { Tabs, Tab } from '@material-ui/core';
const STabsLoader = ({count=1,width,height}) => {
  return(
    <>
    <Tabs
      indicatorColor="primary"
      textColor="primary"
      variant="standard"
      TabIndicatorProps={{ style: { background: "transparent" } }}
      value={0}
    >
      {Array(count).fill(0).map((tab, index) =>
        <Tab value={index} key={index} label={<Skeleton variant="rect" width={ width ? width :136} animation='wave' height={ height ? height :24} />} />
      )}
    </Tabs>
    </>
  )
}
export default STabsLoader;
